import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { ZERO_RESULT_SEARCH_CACHE_KEYS } from "./keys";

import type { ZeroResultSearchFilters } from "@/types";
import { ZeroResultSearchRepository } from "@/repositories/zero-result-search";

export const useGetZeroResultQueries = (filters: ZeroResultSearchFilters) => {
  const repository = useRef(new ZeroResultSearchRepository());

  return useQuery({
    queryKey: ZERO_RESULT_SEARCH_CACHE_KEYS.LIST(filters),
    queryFn: async () => {
      return await repository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
